import React from "react";

// Harmony AI Custom Icon Set - Inline SVG Components
// Bu dosya otomatik generate edilmiştir: npm run generate-svg-components

export interface HarmonyIconProps {
  size?: number | string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  enabled?: boolean;
}

// Individual icon components
export const HarmonyAlertCircle: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M11 7V11M11 15H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyBookClosed: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      d="M16.6667 15.8334V13.3334H5.83334C4.45263 13.3334 3.33334 14.4526 3.33334 15.8334M7.33334 18.3334H14C14.9334 18.3334 15.4001 18.3334 15.7567 18.1517C16.0703 17.9919 16.3252 17.7369 16.485 17.4233C16.6667 17.0668 16.6667 16.6001 16.6667 15.6667V4.33335C16.6667 3.39993 16.6667 2.93322 16.485 2.5767C16.3252 2.2631 16.0703 2.00813 15.7567 1.84834C15.4001 1.66669 14.9334 1.66669 14 1.66669H7.33334C5.93321 1.66669 5.23315 1.66669 4.69837 1.93917C4.22796 2.17885 3.84551 2.56131 3.60583 3.03171C3.33334 3.56649 3.33334 4.26656 3.33334 5.66669V14.3334C3.33334 15.7335 3.33334 16.4336 3.60583 16.9683C3.84551 17.4387 4.22796 17.8212 4.69837 18.0609C5.23315 18.3334 5.93321 18.3334 7.33334 18.3334Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyCheckCircle: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.7071 6.70711C12.0976 6.31658 12.0976 5.68342 11.7071 5.29289C11.3166 4.90237 10.6834 4.90237 10.2929 5.29289L7 8.58579L5.70711 7.29289C5.31658 6.90237 4.68342 6.90237 4.29289 7.29289C3.90237 7.68342 3.90237 8.31658 4.29289 8.70711L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L11.7071 6.70711Z"
      fill="currentColor"
    />
  </svg>
);
export const HarmonyChevronDown: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M1 1L7 7L13 1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyChevronLeft: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M7 13L1 7L7 1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyChevronRight: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M1 13L7 7L1 1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyChevronUp: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M13 7L7 1L1 7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyDotsHorizontal: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <g id="Icon">
      <path
        d="M9 3C9.55228 3 10 2.55228 10 2C10 1.44772 9.55228 1 9 1C8.44772 1 8 1.44772 8 2C8 2.55228 8.44772 3 9 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 3C16.5523 3 17 2.55228 17 2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2C15 2.55228 15.4477 3 16 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const HarmonyDotsVertical: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 4 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <g id="Icon">
      <path
        d="M2 10C2.55228 10 3 9.55228 3 9C3 8.44772 2.55228 8 2 8C1.44772 8 1 8.44772 1 9C1 9.55228 1.44772 10 2 10Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 17C2.55228 17 3 16.5523 3 16C3 15.4477 2.55228 15 2 15C1.44772 15 1 15.4477 1 16C1 16.5523 1.44772 17 2 17Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const HarmonyDownload01: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M19 13V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V13M15 8L10 13M10 13L5 8M10 13V1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyEdit: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    width={size}
    height={size}
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <g clipPath="url(#clip0_4015_3154)">
      <path
        d="M9.16666 3.33332H5.66666C4.26653 3.33332 3.56646 3.33332 3.03168 3.6058C2.56128 3.84549 2.17882 4.22794 1.93914 4.69834C1.66666 5.23312 1.66666 5.93319 1.66666 7.33332V14.3333C1.66666 15.7335 1.66666 16.4335 1.93914 16.9683C2.17882 17.4387 2.56128 17.8212 3.03168 18.0608C3.56646 18.3333 4.26653 18.3333 5.66666 18.3333H12.6667C14.0668 18.3333 14.7669 18.3333 15.3016 18.0608C15.772 17.8212 16.1545 17.4387 16.3942 16.9683C16.6667 16.4335 16.6667 15.7335 16.6667 14.3333V10.8333M6.66663 13.3333H8.06209C8.46974 13.3333 8.67356 13.3333 8.86538 13.2873C9.03544 13.2464 9.19801 13.1791 9.34713 13.0877C9.51533 12.9847 9.65945 12.8405 9.9477 12.5523L17.9167 4.58332C18.607 3.89296 18.607 2.77368 17.9167 2.08332C17.2263 1.39296 16.107 1.39296 15.4167 2.08332L7.44769 10.0523C7.15943 10.3405 7.0153 10.4847 6.91223 10.6528C6.82085 10.802 6.75351 10.9645 6.71268 11.1346C6.66663 11.3264 6.66663 11.5302 6.66663 11.9379V13.3333Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4015_3154">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const HarmonyExclamation: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.84007 1.01948C6.60467 -0.339826 8.56176 -0.339826 9.32637 1.01948L14.9067 10.94C15.6566 12.2732 14.6932 13.9205 13.1635 13.9205H2.00291C0.473259 13.9205 -0.490169 12.2732 0.25976 10.94L5.84007 1.01948ZM8.58313 10.9207C8.58313 11.4729 8.13542 11.9207 7.58313 11.9207C7.03085 11.9207 6.58313 11.4729 6.58313 10.9207C6.58313 10.3684 7.03085 9.92065 7.58313 9.92065C8.13542 9.92065 8.58313 10.3684 8.58313 10.9207ZM7.58313 2.92065C7.03085 2.92065 6.58313 3.36837 6.58313 3.92065V6.92065C6.58313 7.47294 7.03085 7.92065 7.58313 7.92065C8.13541 7.92065 8.58313 7.47294 8.58313 6.92065V3.92065C8.58313 3.36837 8.13541 2.92065 7.58313 2.92065Z"
      fill="currentColor"
    />
  </svg>
);
export const HarmonyGrid01: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <g id="Icon">
      <path
        d="M6.4 1H2.6C2.03995 1 1.75992 1 1.54601 1.10899C1.35785 1.20487 1.20487 1.35785 1.10899 1.54601C1 1.75992 1 2.03995 1 2.6V6.4C1 6.96005 1 7.24008 1.10899 7.45399C1.20487 7.64215 1.35785 7.79513 1.54601 7.89101C1.75992 8 2.03995 8 2.6 8H6.4C6.96005 8 7.24008 8 7.45399 7.89101C7.64215 7.79513 7.79513 7.64215 7.89101 7.45399C8 7.24008 8 6.96005 8 6.4V2.6C8 2.03995 8 1.75992 7.89101 1.54601C7.79513 1.35785 7.64215 1.20487 7.45399 1.10899C7.24008 1 6.96005 1 6.4 1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4 1H13.6C13.0399 1 12.7599 1 12.546 1.10899C12.3578 1.20487 12.2049 1.35785 12.109 1.54601C12 1.75992 12 2.03995 12 2.6V6.4C12 6.96005 12 7.24008 12.109 7.45399C12.2049 7.64215 12.3578 7.79513 12.546 7.89101C12.7599 8 13.0399 8 13.6 8H17.4C17.9601 8 18.2401 8 18.454 7.89101C18.6422 7.79513 18.7951 7.64215 18.891 7.45399C19 7.24008 19 6.96005 19 6.4V2.6C19 2.03995 19 1.75992 18.891 1.54601C18.7951 1.35785 18.6422 1.20487 18.454 1.10899C18.2401 1 17.9601 1 17.4 1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4 12H13.6C13.0399 12 12.7599 12 12.546 12.109C12.3578 12.2049 12.2049 12.3578 12.109 12.546C12 12.7599 12 13.0399 12 13.6V17.4C12 17.9601 12 18.2401 12.109 18.454C12.2049 18.6422 12.3578 18.7951 12.546 18.891C12.7599 19 13.0399 19 13.6 19H17.4C17.9601 19 18.2401 19 18.454 18.891C18.6422 18.7951 18.7951 18.6422 18.891 18.454C19 18.2401 19 17.9601 19 17.4V13.6C19 13.0399 19 12.7599 18.891 12.546C18.7951 12.3578 18.6422 12.2049 18.454 12.109C18.2401 12 17.9601 12 17.4 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.4 12H2.6C2.03995 12 1.75992 12 1.54601 12.109C1.35785 12.2049 1.20487 12.3578 1.10899 12.546C1 12.7599 1 13.0399 1 13.6V17.4C1 17.9601 1 18.2401 1.10899 18.454C1.20487 18.6422 1.35785 18.7951 1.54601 18.891C1.75992 19 2.03995 19 2.6 19H6.4C6.96005 19 7.24008 19 7.45399 18.891C7.64215 18.7951 7.79513 18.6422 7.89101 18.454C8 18.2401 8 17.9601 8 17.4V13.6C8 13.0399 8 12.7599 7.89101 12.546C7.79513 12.3578 7.64215 12.2049 7.45399 12.109C7.24008 12 6.96005 12 6.4 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const HarmonyHelpCircle: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
    width={size}
    height={size}
  >
    <path
      d="M7.61363 7.61353L4.10752 4.10742M4.10752 15.8925L7.64006 12.36M12.3843 12.3864L15.8904 15.8925M15.8904 4.10742L12.3574 7.64047M18.3334 9.99996C18.3334 14.6023 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6023 1.66675 9.99996C1.66675 5.39759 5.39771 1.66663 10.0001 1.66663C14.6025 1.66663 18.3334 5.39759 18.3334 9.99996ZM13.3334 9.99996C13.3334 11.8409 11.841 13.3333 10.0001 13.3333C8.15913 13.3333 6.66675 11.8409 6.66675 9.99996C6.66675 8.15901 8.15913 6.66663 10.0001 6.66663C11.841 6.66663 13.3334 8.15901 13.3334 9.99996Z"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyImage: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
    width={size}
    height={size}
  >
    <path
      d="M3.56007 17.2733L9.05718 11.7761C9.3872 11.4461 9.5522 11.2811 9.74248 11.2193C9.90985 11.1649 10.0901 11.1649 10.2575 11.2193C10.4478 11.2811 10.6128 11.4461 10.9428 11.7761L16.4033 17.2366M11.6667 12.5L14.0572 10.1095C14.3872 9.77946 14.5522 9.61445 14.7425 9.55263C14.9098 9.49825 15.0901 9.49825 15.2575 9.55263C15.4478 9.61445 15.6128 9.77946 15.9428 10.1095L18.3333 12.5M8.33332 7.5C8.33332 8.42047 7.58713 9.16667 6.66666 9.16667C5.74618 9.16667 4.99999 8.42047 4.99999 7.5C4.99999 6.57953 5.74618 5.83333 6.66666 5.83333C7.58713 5.83333 8.33332 6.57953 8.33332 7.5ZM5.66666 17.5H14.3333C15.7335 17.5 16.4335 17.5 16.9683 17.2275C17.4387 16.9878 17.8212 16.6054 18.0608 16.135C18.3333 15.6002 18.3333 14.9001 18.3333 13.5V6.5C18.3333 5.09987 18.3333 4.3998 18.0608 3.86502C17.8212 3.39462 17.4387 3.01217 16.9683 2.77248C16.4335 2.5 15.7335 2.5 14.3333 2.5H5.66666C4.26653 2.5 3.56646 2.5 3.03168 2.77248C2.56128 3.01217 2.17882 3.39462 1.93914 3.86502C1.66666 4.3998 1.66666 5.09987 1.66666 6.5V13.5C1.66666 14.9001 1.66666 15.6002 1.93914 16.135C2.17882 16.6054 2.56128 16.9878 3.03168 17.2275C3.56646 17.5 4.26653 17.5 5.66666 17.5Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyInfoCircle: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyInformationCircle: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55229 6.44772 9 7 9V12C7 12.5523 7.44772 13 8 13H9C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11V8C9 7.44772 8.55228 7 8 7H7Z"
      fill="currentColor"
    />
  </svg>
);
export const HarmonyInputPlaceholder: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <circle
      id="Ellipse 1"
      cx="9"
      cy="9"
      r="8.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const HarmonyLayoutLeft: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
    width={size}
    height={size}
  >
    <path
      d="M7.5 2.5V17.5M6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 12.5L10.8333 10L13.3333 7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyLogOut01: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M14 15L19 10M19 10L14 5M19 10H7M7 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19H7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyMessageChatCircle: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
    width={size}
    height={size}
  >
    <g clipPath="url(#clip0_4015_2836)">
      <path
        d="M5.07872 9.35732C5.02692 9.02351 5.00005 8.68154 5.00005 8.33332C5.00005 4.65142 8.00445 1.66666 11.7106 1.66666C15.4167 1.66666 18.4211 4.65142 18.4211 8.33332C18.4211 9.16505 18.2678 9.9612 17.9877 10.6954C17.9295 10.8479 17.9005 10.9241 17.8872 10.9837C17.8742 11.0426 17.8691 11.0841 17.8677 11.1445C17.8663 11.2055 17.8745 11.2726 17.8911 11.4069L18.2265 14.1321C18.2629 14.4271 18.281 14.5746 18.2319 14.6818C18.1889 14.7758 18.1126 14.8504 18.0177 14.8912C17.9093 14.9378 17.7623 14.9163 17.4682 14.8732L14.8138 14.4841C14.6752 14.4638 14.6059 14.4536 14.5428 14.454C14.4803 14.4543 14.4371 14.4589 14.376 14.4718C14.3143 14.4848 14.2354 14.5143 14.0776 14.5734C13.3415 14.8491 12.5438 15 11.7106 15C11.3621 15 11.0198 14.9736 10.6856 14.9227M6.35973 18.3333C8.83048 18.3333 10.8334 16.2813 10.8334 13.75C10.8334 11.2187 8.83048 9.16666 6.35973 9.16666C3.88898 9.16666 1.88605 11.2187 1.88605 13.75C1.88605 14.2588 1.96698 14.7483 2.11637 15.2056C2.17952 15.3989 2.2111 15.4956 2.22146 15.5616C2.23228 15.6305 2.23418 15.6693 2.23015 15.7389C2.22629 15.8057 2.20959 15.8811 2.1762 16.0319L1.66675 18.3333L4.16242 17.9925C4.29864 17.9739 4.36675 17.9646 4.42622 17.965C4.48885 17.9654 4.52209 17.9688 4.5835 17.981C4.64183 17.9927 4.72855 18.0233 4.90197 18.0845C5.35891 18.2458 5.84934 18.3333 6.35973 18.3333Z"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4015_2836">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const HarmonyMicrophone01: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M15 9V11C15 14.866 11.866 18 8 18M1 9V11C1 14.866 4.13401 18 8 18M8 18V21M4 21H12M8 14C6.34315 14 5 12.6569 5 11V4C5 2.34315 6.34315 1 8 1C9.65685 1 11 2.34315 11 4V11C11 12.6569 9.65685 14 8 14Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyMicrophoneOff01: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M14 8.4V4C14 2.34315 12.6569 1 11 1C9.82238 1 8.80325 1.67852 8.3122 2.66593M11 18V21M11 18C7.13401 18 4 14.866 4 11V9M11 18C14.866 18 18 14.866 18 11V9M7 21H15M1 1L21 21M11 14C9.34315 14 8 12.6569 8 11V8L13.1226 13.12C12.5796 13.6637 11.8291 14 11 14Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyPaperclip: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M18.9779 9.44975L9.96231 18.4654C7.91206 20.5156 4.58794 20.5156 2.53769 18.4654C0.487437 16.4151 0.487437 13.091 2.53769 11.0407L11.5533 2.02513C12.9201 0.658291 15.1362 0.658291 16.503 2.02513C17.8699 3.39196 17.8699 5.60804 16.503 6.97487L7.84099 15.6369C7.15757 16.3203 6.04953 16.3203 5.36612 15.6369C4.6827 14.9535 4.6827 13.8455 5.36612 13.1621L12.9675 5.56066"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyRows01: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <g id="Group 17">
      <path
        id="Icon"
        d="M1.99274 7.16547C1.65063 6.99115 1.37249 6.713 1.19817 6.37089C1 5.98196 1 5.47282 1 4.45455L1 3.90909C1 2.89081 1 2.38167 1.19817 1.99274C1.37249 1.65063 1.65063 1.37249 1.99274 1.19817C2.38168 1 2.89081 1 3.90909 1L14.4545 1C15.4728 1 15.982 1 16.3709 1.19817C16.713 1.37249 16.9912 1.65063 17.1655 1.99274C17.3636 2.38168 17.3636 2.89081 17.3636 3.90909V4.45455C17.3636 5.47282 17.3636 5.98196 17.1655 6.37089C16.9912 6.713 16.713 6.99115 16.3709 7.16547"
        stroke="currentColor"
        strokeWidth="1.51818"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Icon_2"
        d="M14.0909 13L11.9818 10.8909M13.1212 8.15149C13.1212 10.2937 11.3846 12.0303 9.24244 12.0303C7.10024 12.0303 5.36365 10.2937 5.36365 8.15149C5.36365 6.0093 7.10024 4.27271 9.24244 4.27271C11.3846 4.27271 13.1212 6.0093 13.1212 8.15149Z"
        stroke="currentColor"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const HarmonySearchMd: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    width={size}
    height={size}
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonySettings02: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <g id="Icon">
      <path
        d="M7.35012 18.3711L7.93457 19.6856C8.1083 20.0768 8.39184 20.4093 8.75079 20.6426C9.10974 20.8759 9.52867 21.0001 9.95679 21C10.3849 21.0001 10.8038 20.8759 11.1628 20.6426C11.5217 20.4093 11.8053 20.0768 11.979 19.6856L12.5635 18.3711C12.7715 17.9047 13.1215 17.5159 13.5635 17.26C14.0082 17.0034 14.5228 16.8941 15.0335 16.9478L16.4635 17.1C16.8891 17.145 17.3187 17.0656 17.7001 16.8713C18.0816 16.6771 18.3984 16.3763 18.6123 16.0056C18.8265 15.635 18.9286 15.2103 18.9061 14.7829C18.8836 14.3555 18.7376 13.9438 18.4857 13.5978L17.639 12.4344C17.3375 12.0171 17.1764 11.5148 17.179 11C17.1789 10.4866 17.3415 9.98635 17.6435 9.57111L18.4901 8.40778C18.742 8.06175 18.888 7.65007 18.9105 7.22267C18.933 6.79528 18.831 6.37054 18.6168 6C18.4029 5.62923 18.086 5.32849 17.7046 5.13423C17.3232 4.93997 16.8936 4.86053 16.4679 4.90556L15.0379 5.05778C14.5272 5.11141 14.0127 5.00212 13.5679 4.74556C13.125 4.48825 12.775 4.09736 12.5679 3.62889L11.979 2.31444C11.8053 1.92317 11.5217 1.59072 11.1628 1.3574C10.8038 1.12408 10.3849 0.99993 9.95679 1C9.52867 0.99993 9.10974 1.12408 8.75079 1.3574C8.39184 1.59072 8.1083 1.92317 7.93457 2.31444L7.35012 3.62889C7.14305 4.09736 6.79299 4.48825 6.35012 4.74556C5.90534 5.00212 5.39079 5.11141 4.88012 5.05778L3.44568 4.90556C3.02001 4.86053 2.59042 4.93997 2.20899 5.13423C1.82757 5.32849 1.51069 5.62923 1.29679 6C1.08261 6.37054 0.98057 6.79528 1.00305 7.22267C1.02554 7.65007 1.17158 8.06175 1.42345 8.40778L2.27012 9.57111C2.57206 9.98635 2.73466 10.4866 2.73456 11C2.73466 11.5134 2.57206 12.0137 2.27012 12.4289L1.42345 13.5922C1.17158 13.9382 1.02554 14.3499 1.00305 14.7773C0.98057 15.2047 1.08261 15.6295 1.29679 16C1.5109 16.3706 1.82782 16.6712 2.20918 16.8654C2.59055 17.0596 3.02004 17.1392 3.44568 17.0944L4.87568 16.9422C5.38634 16.8886 5.90089 16.9979 6.34568 17.2544C6.7902 17.511 7.14188 17.902 7.35012 18.3711Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.955 14C11.6119 14 12.955 12.6569 12.955 11C12.955 9.34315 11.6119 8 9.955 8C8.29815 8 6.955 9.34315 6.955 11C6.955 12.6569 8.29815 14 9.955 14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const HarmonySettings03: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M13.0505 7H3.5C2.11929 7 1 5.88071 1 4.5C1 3.11929 2.11929 2 3.5 2H13.0505M6.94949 18H16.5C17.8807 18 19 16.8807 19 15.5C19 14.1193 17.8807 13 16.5 13H6.94949M1 15.5C1 17.433 2.567 19 4.5 19C6.433 19 8 17.433 8 15.5C8 13.567 6.433 12 4.5 12C2.567 12 1 13.567 1 15.5ZM19 4.5C19 6.433 17.433 8 15.5 8C13.567 8 12 6.433 12 4.5C12 2.567 13.567 1 15.5 1C17.433 1 19 2.567 19 4.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyShare01: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M19 10V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V10M14 5L10 1M10 1L6 5M10 1V13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyShoppingCart: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
    width={size}
    height={size}
  >
    <path
      d="M2 3.99998L4 1.33331H12L14 3.99998M2 3.99998V13.3333C2 13.6869 2.14048 14.0261 2.39052 14.2761C2.64057 14.5262 2.97971 14.6666 3.33333 14.6666H12.6667C13.0203 14.6666 13.3594 14.5262 13.6095 14.2761C13.8595 14.0261 14 13.6869 14 13.3333V3.99998M2 3.99998H14M10.6667 6.66665C10.6667 7.37389 10.3857 8.05217 9.88562 8.55226C9.38552 9.05236 8.70724 9.33331 8 9.33331C7.29276 9.33331 6.61448 9.05236 6.11438 8.55226C5.61428 8.05217 5.33333 7.37389 5.33333 6.66665"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyStar06: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M3.5 21V16M3.5 6V1M1 3.5H6M1 18.5H6M12 2L10.2658 6.50886C9.98381 7.24209 9.8428 7.60871 9.62353 7.91709C9.42919 8.1904 9.1904 8.42919 8.91709 8.62353C8.60871 8.84281 8.24209 8.98381 7.50886 9.26582L3 11L7.50886 12.7342C8.24209 13.0162 8.60871 13.1572 8.91709 13.3765C9.1904 13.5708 9.42919 13.8096 9.62353 14.0829C9.84281 14.3913 9.98381 14.7579 10.2658 15.4911L12 20L13.7342 15.4911C14.0162 14.7579 14.1572 14.3913 14.3765 14.0829C14.5708 13.8096 14.8096 13.5708 15.0829 13.3765C15.3913 13.1572 15.7579 13.0162 16.4911 12.7342L21 11L16.4911 9.26582C15.7579 8.98381 15.3913 8.8428 15.0829 8.62353C14.8096 8.42919 14.5708 8.1904 14.3765 7.91709C14.1572 7.60871 14.0162 7.24209 13.7342 6.50886L12 2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyUserPlus01: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M11 13.5H6.5C5.10444 13.5 4.40665 13.5 3.83886 13.6722C2.56045 14.06 1.56004 15.0605 1.17224 16.3389C1 16.9067 1 17.6044 1 19M18 19V13M15 16H21M13.5 5.5C13.5 7.98528 11.4853 10 9 10C6.51472 10 4.5 7.98528 4.5 5.5C4.5 3.01472 6.51472 1 9 1C11.4853 1 13.5 3.01472 13.5 5.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyXCircle: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L6.58579 8L5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071C5.68342 11.0976 6.31658 11.0976 6.70711 10.7071L8 9.41421L9.29289 10.7071C9.68342 11.0976 10.3166 11.0976 10.7071 10.7071C11.0976 10.3166 11.0976 9.68342 10.7071 9.29289L9.41421 8L10.7071 6.70711C11.0976 6.31658 11.0976 5.68342 10.7071 5.29289C10.3166 4.90237 9.68342 4.90237 9.29289 5.29289L8 6.58579L6.70711 5.29289Z"
      fill="currentColor"
    />
  </svg>
);
export const HarmonyXClose: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      id="Icon"
      d="M13 1L1 13M1 1L13 13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HarmonyChatSend: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      d="M7.74928 10.2501L10.0457 7.95373M7.85559 10.5235L10.0457 16.1552C10.2386 16.6513 10.3351 16.8994 10.4741 16.9718C10.5946 17.0346 10.7381 17.0347 10.8587 16.972C10.9978 16.8998 11.0946 16.6518 11.2881 16.1559L16.78 2.08281C16.9547 1.63516 17.0421 1.41133 16.9943 1.26831C16.9528 1.1441 16.8553 1.04663 16.7311 1.00514C16.5881 0.957356 16.3643 1.0447 15.9166 1.21939L1.84349 6.71134C1.34759 6.90486 1.09965 7.00163 1.02739 7.14071C0.964749 7.26129 0.964833 7.40483 1.02761 7.52533C1.10004 7.66433 1.3481 7.7608 1.84422 7.95373L7.47589 10.1438C7.5766 10.183 7.62695 10.2026 7.66935 10.2328C7.70693 10.2596 7.7398 10.2925 7.7666 10.3301C7.79685 10.3725 7.81643 10.4228 7.85559 10.5235Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HarmonyHamburger: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
  >
    <path
      d="M3 12H21M3 6H21M3 18H15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HarmonyDiamond: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 21"
    fill="none"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
    width={size}
    height={size}
  >
    <path
      d="M2.08295 8H17.9163M8.33295 3L6.66628 8L9.99961 17.5833L13.3329 8L11.6663 3M10.5118 17.3854L17.9773 8.42679C18.1038 8.27496 18.1671 8.19905 18.1912 8.1143C18.2126 8.03959 18.2126 7.96041 18.1912 7.88569C18.1671 7.80095 18.1038 7.72504 17.9773 7.57321L14.3662 3.23988C14.2927 3.1517 14.256 3.10762 14.2109 3.07592C14.171 3.04784 14.1265 3.02698 14.0794 3.01431C14.0262 3 13.9688 3 13.854 3H6.1452C6.03042 3 5.97303 3 5.91985 3.01431C5.87273 3.02698 5.82821 3.04784 5.7883 3.07592C5.74327 3.10762 5.70653 3.1517 5.63305 3.23988L2.02194 7.57321C1.89541 7.72504 1.83215 7.80095 1.80798 7.88569C1.78666 7.96041 1.78666 8.03959 1.80798 8.1143C1.83215 8.19904 1.89541 8.27496 2.02194 8.42679L9.48747 17.3854C9.66335 17.5965 9.75129 17.702 9.85657 17.7405C9.94894 17.7743 10.0503 17.7743 10.1427 17.7405C10.2479 17.702 10.3359 17.5965 10.5118 17.3854Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HarmonySparkles: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
    width={size}
    height={size}
  >
    <g clipPath="url(#clip0_156_35009)">
      <path
        d="M4.33301 8.66634L4.85598 9.71229C5.03297 10.0663 5.12147 10.2433 5.23969 10.3966C5.3446 10.5327 5.46661 10.6547 5.60271 10.7597C5.75608 10.8779 5.93308 10.9664 6.28706 11.1434L7.33301 11.6663L6.28706 12.1893C5.93308 12.3663 5.75608 12.4548 5.60271 12.573C5.46661 12.6779 5.3446 12.7999 5.23969 12.936C5.12147 13.0894 5.03297 13.2664 4.85598 13.6204L4.33301 14.6663L3.81004 13.6204C3.63304 13.2664 3.54455 13.0894 3.42632 12.936C3.32141 12.7999 3.1994 12.6779 3.06331 12.573C2.90993 12.4548 2.73294 12.3663 2.37895 12.1893L1.33301 11.6663L2.37895 11.1434C2.73294 10.9664 2.90993 10.8779 3.06331 10.7597C3.1994 10.6547 3.32141 10.5327 3.42632 10.3966C3.54455 10.2433 3.63304 10.0663 3.81004 9.71229L4.33301 8.66634Z"
        fill="currentColor"
      />
      <path
        d="M9.99967 1.33301L10.7854 3.37595C10.9734 3.86477 11.0674 4.10918 11.2136 4.31477C11.3432 4.49698 11.5024 4.65617 11.6846 4.78573C11.8902 4.93191 12.1346 5.02592 12.6234 5.21393L14.6663 5.99967L12.6234 6.78542C12.1346 6.97343 11.8902 7.06743 11.6846 7.21362C11.5024 7.34318 11.3432 7.50237 11.2136 7.68458C11.0674 7.89017 10.9734 8.13458 10.7854 8.6234L9.99967 10.6663L9.21393 8.62339C9.02592 8.13458 8.93191 7.89017 8.78573 7.68458C8.65617 7.50237 8.49698 7.34318 8.31477 7.21362C8.10918 7.06743 7.86477 6.97343 7.37595 6.78542L5.33301 5.99967L7.37595 5.21393C7.86477 5.02592 8.10918 4.93191 8.31477 4.78573C8.49698 4.65617 8.65617 4.49698 8.78573 4.31477C8.93191 4.10918 9.02592 3.86477 9.21393 3.37595L9.99967 1.33301Z"
        fill="currentColor"
      />
      <path
        d="M4.33301 8.66634L4.85598 9.71229C5.03297 10.0663 5.12147 10.2433 5.23969 10.3966C5.3446 10.5327 5.46661 10.6547 5.60271 10.7597C5.75608 10.8779 5.93308 10.9664 6.28706 11.1434L7.33301 11.6663L6.28706 12.1893C5.93308 12.3663 5.75608 12.4548 5.60271 12.573C5.46661 12.6779 5.3446 12.7999 5.23969 12.936C5.12147 13.0894 5.03297 13.2664 4.85598 13.6204L4.33301 14.6663L3.81004 13.6204C3.63304 13.2664 3.54455 13.0894 3.42632 12.936C3.32141 12.7999 3.1994 12.6779 3.06331 12.573C2.90993 12.4548 2.73294 12.3663 2.37895 12.1893L1.33301 11.6663L2.37895 11.1434C2.73294 10.9664 2.90993 10.8779 3.06331 10.7597C3.1994 10.6547 3.32141 10.5327 3.42632 10.3966C3.54455 10.2433 3.63304 10.0663 3.81004 9.71229L4.33301 8.66634Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99967 1.33301L10.7854 3.37595C10.9734 3.86477 11.0674 4.10918 11.2136 4.31477C11.3432 4.49698 11.5024 4.65617 11.6846 4.78573C11.8902 4.93191 12.1346 5.02592 12.6234 5.21393L14.6663 5.99967L12.6234 6.78542C12.1346 6.97343 11.8902 7.06743 11.6846 7.21362C11.5024 7.34318 11.3432 7.50237 11.2136 7.68458C11.0674 7.89017 10.9734 8.13458 10.7854 8.6234L9.99967 10.6663L9.21393 8.62339C9.02592 8.13458 8.93191 7.89017 8.78573 7.68458C8.65617 7.50237 8.49698 7.34318 8.31477 7.21362C8.10918 7.06743 7.86477 6.97343 7.37595 6.78542L5.33301 5.99967L7.37595 5.21393C7.86477 5.02592 8.10918 4.93191 8.31477 4.78573C8.49698 4.65617 8.65617 4.49698 8.78573 4.31477C8.93191 4.10918 9.02592 3.86477 9.21393 3.37595L9.99967 1.33301Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_156_35009">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HarmonyTemoporaryChatIcon: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
  enabled = false,
}) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
    width={size}
    height={size}
  >
    <path
      d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="3 3"
    />
    {enabled && (
      <path
        d="M15 9L10 14M10 9L15 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </svg>
);

export const OmuzLogo: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    viewBox="0 0 373 377"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
    width={size}
    height={size}
  >
    <path
      d="M260.158 326.823C237.089 315.351 212.624 309.18 183.193 309.18C175.106 308.89 163.613 310.589 152.242 313.032C120.635 319.783 93.6668 335.23 70.803 358.008C66.2056 362.564 66.3698 363.724 71.8292 367.368C89.603 379.213 107.951 380.29 126.628 369.729C143.663 360.079 161.971 354.612 181.304 353.784C200.884 352.914 219.848 356.6 237.581 365.422C241.645 367.451 245.585 369.646 249.731 371.51C268.326 379.917 286.1 378.592 302.806 366.457C306.829 363.558 306.665 363.227 303.299 359.499C290.82 345.957 276.454 334.94 260.158 326.823Z"
      fill="currentColor"
    />
    <path
      d="M45.8463 108.157C38.3345 94.3243 29.0166 81.9413 17.4821 71.2563C13.993 68.0259 12.5153 68.0673 9.64194 71.8361C1.96596 81.9827 -0.373779 93.6617 0.200894 106.169C0.69347 116.73 5.45504 125.717 10.0114 134.869C25.938 167.007 27.1284 199.808 14.1162 233.23C11.6122 239.732 8.08211 245.737 5.2498 252.032C-3.12399 270.586 -1.39998 288.311 9.84718 305.167C12.5974 309.309 13.952 309.392 17.4821 305.995C21.8332 301.813 25.897 297.34 29.7144 292.619C54.2201 262.303 65.8777 227.432 66.7397 188.626C67.0271 179.639 65.8367 170.818 64.441 162.038C61.4445 142.987 55 125.096 45.8463 108.157Z"
      fill="currentColor"
    />
    <path
      d="M350.834 176.28C352.763 159.673 357.32 144.018 365.488 129.481C370.209 121.033 372.918 112.004 373 102.603C372.754 90.7998 369.593 80.4047 362.902 71.1692C360.029 67.2347 359.372 67.1519 355.924 70.258C349.849 75.8076 344.513 82.1027 339.628 88.6876C328.052 104.26 319.391 121.364 313.604 139.959C306.831 161.826 305.23 184.19 307.405 206.803C309.868 232.066 318.57 255.258 331.747 276.835C338.232 287.437 346.36 296.631 354.693 305.701C358.141 309.429 359.659 309.18 363.066 305.328C363.641 304.666 364.216 304.003 364.626 303.258C369.47 295.348 372.343 286.857 372.836 277.539C373.411 266.357 370.291 256.211 365.037 246.437C353.379 224.57 347.92 201.336 350.834 176.28Z"
      fill="currentColor"
    />
    <path
      d="M302.603 9.99884C294.353 4.15935 285.281 0.680507 275.019 0.183529C263.402 -0.354863 252.976 2.75125 243.001 8.50791C235.12 13.0221 226.788 16.6252 217.962 18.7788C193.99 24.6597 170.264 24.3284 146.744 16.1696C138.329 13.2706 130.694 8.75639 122.69 5.07048C105.45 -2.92258 88.7841 -1.22457 72.7343 8.46649C71.4618 9.25337 70.3946 10.3302 69.2863 11.3655C67.1518 13.3534 67.0697 15.3413 69.081 17.5777C71.8723 20.6424 75.3203 22.9203 78.2347 25.7779C91.0417 38.0367 105.86 47.0651 121.951 54.2299C142.352 63.2583 163.82 67.1927 185.698 68.1038C201.256 67.5654 216.361 65.6603 231.139 61.436C259.133 53.4016 283.064 38.6165 303.301 17.6606C306.79 14.0575 306.749 12.9393 302.603 9.99884Z"
      fill="currentColor"
    />
    <path
      d="M257.03 164.575C251.489 145.855 240.529 131.567 224.068 122.207C203.873 110.694 182.528 108.913 160.567 116.078C143.163 121.752 129.453 132.437 120.463 149.168C113.362 162.38 110.324 176.626 110.899 191.701C111.761 214.107 118.657 233.489 135.815 248.357C151.578 262.024 169.844 267.201 189.752 266.786C199.563 266.579 209.209 264.012 218.199 259.829C232.894 252.995 244.346 242.352 251.94 227.359C258.056 215.308 260.355 202.469 259.657 188.43C260.273 180.685 259.37 172.568 257.03 164.575ZM219.348 209.882C215.448 217.958 209.62 223.715 202.108 227.401C197.51 229.637 192.585 231.045 187.577 231.17C177.397 231.377 168.079 228.602 160.034 221.23C151.29 213.196 147.76 202.759 147.309 190.666C147.021 182.549 148.54 174.845 152.193 167.722C156.791 158.694 163.81 152.937 172.676 149.872C183.882 146.021 194.76 146.973 205.104 153.186C213.478 158.238 219.102 165.941 221.934 176.047C223.124 180.354 223.576 184.744 223.289 188.927C223.617 196.464 222.468 203.38 219.348 209.882Z"
      fill="currentColor"
    />
  </svg>
);

export const HarmonyWardrobe: React.FC<HarmonyIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`harmony-icon ${className}`}
    style={style}
    onClick={onClick}
    width={size}
    height={size}
  >
    <path
      d="M5 16.667V18.3337M15 16.667V18.3337"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 11.667V6.66699C2.5 4.30997 2.5 3.13146 3.27531 2.39923C4.05061 1.66699 5.29845 1.66699 7.79412 1.66699H12.2059C14.7016 1.66699 15.9494 1.66699 16.7247 2.39923C17.5 3.13146 17.5 4.30997 17.5 6.66699V11.667C17.5 14.024 17.5 15.2025 16.7247 15.9347C15.9494 16.667 14.7016 16.667 12.2059 16.667H7.79412C5.29845 16.667 4.05061 16.667 3.27531 15.9347C2.5 15.2025 2.5 14.024 2.5 11.667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 16.667V1.66699"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 8.33301V9.16634"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// All icons export object
export const HarmonyIcons = {
  AlertCircle: HarmonyAlertCircle,
  BookClosed: HarmonyBookClosed,
  CheckCircle: HarmonyCheckCircle,
  ChevronDown: HarmonyChevronDown,
  ChevronLeft: HarmonyChevronLeft,
  ChevronRight: HarmonyChevronRight,
  ChevronUp: HarmonyChevronUp,
  DotsHorizontal: HarmonyDotsHorizontal,
  DotsVertical: HarmonyDotsVertical,
  Download01: HarmonyDownload01,
  Edit: HarmonyEdit,
  Exclamation: HarmonyExclamation,
  Grid01: HarmonyGrid01,
  HelpCircle: HarmonyHelpCircle,
  Image: HarmonyImage,
  InfoCircle: HarmonyInfoCircle,
  InformationCircle: HarmonyInformationCircle,
  InputPlaceholder: HarmonyInputPlaceholder,
  LayoutLeft: HarmonyLayoutLeft,
  LogOut01: HarmonyLogOut01,
  MessageChatCircle: HarmonyMessageChatCircle,
  Microphone01: HarmonyMicrophone01,
  MicrophoneOff01: HarmonyMicrophoneOff01,
  Paperclip: HarmonyPaperclip,
  Rows01: HarmonyRows01,
  SearchMd: HarmonySearchMd,
  Settings02: HarmonySettings02,
  Settings03: HarmonySettings03,
  Share01: HarmonyShare01,
  ShoppingCart: HarmonyShoppingCart,
  Star06: HarmonyStar06,
  UserPlus01: HarmonyUserPlus01,
  XCircle: HarmonyXCircle,
  XClose: HarmonyXClose,
  Hamburger: HarmonyHamburger,
  Diamond: HarmonyDiamond,
  HarmonySparkles: HarmonySparkles,
  HarmonyTemoporaryChatIcon: HarmonyTemoporaryChatIcon,
  OmuzLogo: OmuzLogo,
} as const;

// Icon names türü
export type HarmonyIconName = keyof typeof HarmonyIcons;

// Main export
export default HarmonyIcons;
